import { API, Auth } from "aws-amplify";
import { createContext, useEffect, useState } from "react";
import { createUsers } from "../src/graphql/mutations";
import { getUsers } from "../src/graphql/queries";
import * as Notifications from "expo-notifications";
import { Alert, Platform } from "react-native";

export const UserContext = createContext({});

export default function UserContextProvider({ children }) {
  const [user, setUser] = useState({
    user: null,
    refreshUser: async () => {
      await retrieveUser();
    },
  });

  useEffect(() => {
    retrieveUser(true);
  }, []);

  async function currAuthenticated() {
    try {
      await Auth.currentAuthenticatedUser();
      return true;
    } catch (error) {
      return false;
    }
  }

  const retrieveUser = async () => {
    if (await currAuthenticated()) {
      const currUser = await Auth.currentUserInfo();
      const potentialUser = await getUserFromDatabase(currUser);
      setUser({
        user: potentialUser,
        refreshUser: async () => {
          await retrieveUser();
        },
      });
    } else
      setUser({
        user: null,
        refreshUser: async () => {
          await retrieveUser();
        },
      });
  };

  async function getUserFromDatabase(cognitoUser) {
    if (cognitoUser?.attributes?.sub == null) {
      return null;
    }
    const dynamoUser = await API.graphql({
      query: getUsers,
      variables: { uId: cognitoUser.attributes.sub },
    });

    if (dynamoUser == null || dynamoUser.data.getUsers == null) {
      let student = checkStudent(cognitoUser.attributes.email);
      if (Platform.OS != "web") {
        const pushTokenData = await Notifications.getExpoPushTokenAsync({
          projectId: "20a80c44-3529-40e0-bc24-df0d720da374",
        });
        await addUser(cognitoUser, pushTokenData.data, student);
        Alert.alert(
          "Welcome to Uncaged! Click the info icon located next to the titles to learn more about the features!"
        );
      } else {
        await addUser(cognitoUser, "", student);
        window.confirm(
          "Welcome to Uncaged! Click the info icon located next to the titles to learn more about the features!"
        );
      }
      const matchingNewUser = await API.graphql({
        query: getUsers,
        variables: { uId: cognitoUser.attributes.sub },
      });
      return matchingNewUser;
    }
    return dynamoUser;
  }

  function checkStudent(cognitoUser) {
    if (
      cognitoUser.indexOf("@cusdk8.org") !== -1 ||
      cognitoUser.indexOf("@room3") !== -1
    )
      return true;
    return false;
  }

  async function addUser(cognitoUser, pushToken, student) {
    try {
      await API.graphql({
        query: createUsers,
        variables: {
          input: {
            uId: cognitoUser.attributes.sub,
            userName: cognitoUser.attributes.name,
            pushToken: pushToken,
            student: student,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }
  if (typeof user != "undefined")
    return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}
